import { getBrowserType } from '@/app-shared/utils/getBrowserType.js';
import regRule from '@/app-shared/utils/reg-rule.js';
import { setGlobalEnv, setGlobalRequestHeaders } from '@vhcl/core';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
// import HEX from 'crypto-js/enc-hex';
import MODE_ECB from 'crypto-js/mode-ecb';
import PAD_PKCS7 from 'crypto-js/pad-pkcs7';
import 'url-polyfill'; // 兼容支持, 包含完整的URL和URLSearchParams实现

/**
 * Created by yangxy on 2022/01/13.
 * 通用工具类
 */
export const hasOwnProperty = function (obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

/**
 * 删除url中的query参数，并返回新的url
 * @param {*} url
 * @param {*} parameter
 * @returns
 * 示例：
 * var url = 'http://www.example.com/?param1=value1&param2=value2&param3=value3';
 * var newUrl = removeUrlParameter(url, 'param2');
 * console.log(newUrl); // 输出 http://www.example.com/?param1=value1&param3=value3
 */
export function removeUrlParameter(url, parameter) {
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);
    for (let i = 0; i < pars.length; i++) {
      if (pars[i].indexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    return url;
  } else {
    return url;
  }
}

/**
 * 延迟执行(setTimeout的promify写法)
 * @param {*} ms 毫秒数
 * @returns {Promise}
 */
export const sleep = function (ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
};

/**
 * 封装使用事件驱动需要的参数
 * @param cuid 当前组件的唯一标识
 * @param method 当前组件配置的动作
 * @param params 动态参数
 */
export function boxEventOpitons(cuid, method, params) {
  const actions = window.$serverConfig?.[cuid]?.[method];
  return {
    actions,
    params,
    cuid,
    method
  };
}

/**
 * 计算uuid唯一标识
 */
export function uuid() {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;
  let r;

  uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';

  for (i = 0; i < 36; i++) {
    if (!uuid[i]) {
      r = 0 | (Math.random() * 16);
      uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
    }
  }
  return uuid.join('');
}

/**
 * @description 校验当前所在浏览器环境
 * @return Boolean {*}
 */

// 是否微信
export function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  const isWechat = ua.indexOf('micromessenger') > -1 && !isWechatCom() && !isWxMini();
  console.log('isWechat 是否为微信', isWechat);
  return isWechat;
}

//是否在微信小程序内
export function isWxMini() {
  // 全局变量判断（兼容老版本）
  if (window?.__wxjs_environment === 'miniprogram') {
    return true;
  }
  // 从微信7.0.0开始
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('miniprogram') > -1) {
    return true;
  }
  return false;
}

// 是否在普通微信或小程序环境
export function isWechatOrMini() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') > -1 && !isWechatCom();
}

// 是否qq浏览器
export function isQQ() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('qq') > -1;
}

// 是否企业微信
export function isWechatCom() {
  const ua = navigator.userAgent.toLowerCase();
  const isWechatCom = ua.indexOf('wxwork') > -1;
  console.log('isWechatCom 是否为企业微信', isWechatCom);
  return isWechatCom;
}

// 是否移动端
export function isMobile() {
  return regRule.isMobile.test(navigator.userAgent);
}

// 获取地址栏参数
export function getQueryString(name) {
  const reg = regRule.urlAnalysis(name);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

/**
 * 获取上报os操作系统
 */
export function getVhallReportOs() {
  const { system } = getBrowserType();
  let os = 0; // 上报默认值
  if (system === 'windows') {
    os = 12;
  } else if (system === 'macos') {
    console.warn('getVhallReportOs--------->暂时没有指定该类型');
  } else if (system === 'android') {
    os = 10;
  } else if (system === 'ios') {
    os = 11;
  }
  return os;
}

/**
 * 手机号验证
 * */
export const validPhone = (rule, value, vueThis) => {
  const reg = regRule.mobile;
  if (!value) {
    return vueThis ? vueThis.$t('account.account_1025') : '请填写手机号码';
  } else if (!reg.test(value)) {
    return vueThis ? vueThis.$t('account.account_1069') : '请填写正确的手机号码';
  } else {
    return true;
  }
};
/**
 * 邮箱验证
 * */
export const validEmail = (required, value, vueThis) => {
  const reg = regRule.email;
  if (!value && required) {
    return vueThis ? vueThis.$t('form.form_1007') : '请填写邮箱';
  } else if (value.length > 80) {
    return vueThis ? vueThis.$t('form.form_1009') : '邮箱长度不能大于80';
  } else if (value && !reg.test(value)) {
    return vueThis ? vueThis.$t('form.form_1010') : '请填写正确的邮箱';
  } else {
    return true;
  }
};
/**
 * 转化简介
 * @param {*} value
 * @returns
 */
export const replaceHtml = (str, length = 42) => {
  let desc = null;
  desc = str.replace(/&nbsp;/g, '');
  desc = desc
    .replace(/<[^<>&]+>/g, '')
    .replace(/&(lt|gt|nbsp|amp|quot|middot);/gi, '')
    .replace(/(\r\n)|(\n)/g, '');
  desc = desc.replace(/<[^>]+>/g, ''); // 截取html标签
  desc = desc.length > length ? `${desc.trim().substring(0, length)}...` : desc.trim();
  return desc;
};

/**
 * 转换html文本中的xss(仅替换script与style标签)
 * @param {*} string
 * @returns string
 */
export const replaceXss = htmltext => {
  const scriptReg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/g;
  const styleReg = /<style(([\s\S])*?)<\/style>/g;
  return `${htmltext}`.replace(scriptReg, '').replace(styleReg, '');
};

/**
 * 过滤字符串中的 " ' & < > 防止xss
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 */

export function escapeHtml(string) {
  const matchHtmlRegExp = /["'&<>]/;
  let str = '' + string;
  let match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  let escape;
  let html = '';
  let index = 0;
  let lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

/**
 * @description 多次替换对一个问题做替换(使用uuid作为占位符)
 * @param longText String 替换前文本
 * @param rules Array 替换前后的数据封装体
 * @returns string
 */
export const replaceWithRules = (longText, rules = []) => {
  rules.forEach(rule => {
    rule.tempSign = uuid(); // 先替换为占位符
    longText = longText.replace(rule.before, rule.tempSign);
  });
  rules.forEach(rule => {
    longText = longText.replace(rule.tempSign, rule.after);
  });
  return longText;
};

/**
 * @description 获取浏览器的cookie (当前域下,且非http-only)
 */
export const getCookie = name => {
  var reg = regRule.getCookie(name);
  var arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return '';
  }
};

export const isFunction = val => {
  return typeof val === 'function';
};

export const handleIntroInfo = str => {
  if (!str) return '';
  const regImg = regRule.img;
  const imgArr = str.match(regImg);
  const strArr = str.split(regImg);
  // const regUrl =
  //   /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/g;
  // strArr.forEach((item, index) => {
  //   const tempStr = item.replace(regUrl, function (match) {
  //     return `<a class='show-link' href='${match}' target='_blank'>${match}</a>`;
  //   });
  //   strArr[index] = tempStr;
  // });
  if (imgArr) {
    const imgArrLength = imgArr.length;
    let imgIndex = 0;
    for (let strIndex = 0; strIndex < imgArrLength; ++strIndex) {
      strArr.splice(strIndex + imgIndex + 1, 0, imgArr[imgIndex]);
      imgIndex++;
    }
  }
  return strArr.join('');
};

// 去除不必要的地址栏参数 delUrlParams(window.location.search, ['isIndependent']);
export function delUrlParams(searchUrl, keyList) {
  const urlParam = searchUrl.substring(1); //页面参数
  let nextUrl = '';
  var arr = new Array();
  if (urlParam != '') {
    const urlParamArr = urlParam.split('&'); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      let paramArr = urlParamArr[i].split('='); //将参数键，值拆开
      //如果键与要删除的不一致，则加入到参数中
      if (!keyList.includes(paramArr[0])) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&');
  }
  console.log('当前地址栏结果', nextUrl);
  return nextUrl;
}
// 判断是否IE
export function isIE() {
  return (
    !!window.ActiveXObject || 'ActiveXObject' in window || navigator.userAgent.indexOf('Edge') > -1
  );
}

/**
 * 将 queryString 转换成 key-value 形式
 * @param {String} url url地址
 * @returns object
 */
export const parseQueryString = url => {
  if (url.indexOf('http') == -1) {
    const protocol = window.location.protocol;
    url = `${protocol}${url}`;
  }
  return [...new URL(url).searchParams].reduce(
    (cur, [key, value]) => ((cur[key] = value), cur),
    {}
  );
};

/**
 * @description 拼接地址栏参数，自带去重
 */
export const getUrl = (url = '', data = {}) => {
  const qsObj = parseQueryString(url);
  // 截取除去queryString的部分
  const indexOfSeparator = url.indexOf('?');
  if (indexOfSeparator > -1) {
    url = url.substring(0, indexOfSeparator);
  }
  // 去重拼接
  return (
    url +
    '?' +
    getParam({
      ...qsObj,
      ...data
    })
  );
};

/**
 * @description 传入对象返回url参数
 */
export const getParam = data => {
  let url = '';
  for (let k in data) {
    let value = data[k] !== undefined ? data[k] : '';
    url += `&${k}=${encodeURIComponent(value)}`;
  }
  return url ? url.substring(1) : '';
};

// 复制文本到剪贴板
export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // 回退到 execCommand 方法（可选）
    return doCopy(text);
  }
}
/**
 * 复制方法 兼容ios
 * @param 复制值
 * @description 复制方法
 */
export const doCopy = textString => {
  let input = document.querySelector('#copy-input');
  if (!input) {
    input = document.createElement('input');
    input.id = 'copy-input';
    input.readOnly = 'readOnly'; // 防止ios聚焦触发键盘事件
    input.style.position = 'absolute';
    input.style.left = '-1000px';
    input.style.zIndex = '-1000';
    input.style.border = 'none';
    document.body.appendChild(input);
  }

  input.value = textString;
  // ios必须先选中文字且不支持 input.select();
  selectText(input, 0, textString.length);
  let successful = false;
  try {
    successful = document.execCommand('copy');
  } catch (err) {
    // console.error('无法执行复制命令:', err);
    successful = false;
  }
  input.blur();
  return successful;

  // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
  // 选择文本。createTextRange(setSelectionRange)是input方法
  function selectText(textbox, startIndex, stopIndex) {
    if (textbox.createTextRange) {
      //ie
      const range = textbox.createTextRange();
      range.collapse(true);
      range.moveStart('character', startIndex); //起始光标
      range.moveEnd('character', stopIndex - startIndex); //结束光标
      range.select(); //不兼容苹果
    } else {
      //firefox/chrome
      textbox.setSelectionRange(startIndex, stopIndex);
      textbox.focus();
    }
  }
};

/**
 * @description 获取当前设备是否支持IOS底部安全区域，高度
 */
export const getIosSafeArea = data => {
  let newElement = document.createElement('div');
  newElement.className = 'fixIos';
  document.body.appendChild(newElement);
  const h = document.querySelector('.fixIos').clientHeight;
  newElement.remove();
  console.log('是否是IOS小黑条适配', h);
  return h;
};

export const sizeTostr = size => {
  var data = '';
  size = size * 1;
  if (size < 0.5 * 1024) {
    //如果小于0.1KB转化成B
    data = size.toFixed(2) + 'B';
  } else if (size < 0.5 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(2) + 'KB';
  } else if (size < 0.5 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(2) + 'M';
  } else {
    //其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + 'G';
  }
  var sizestr = data + '';
  var len = sizestr.indexOf('.');
  var dec = sizestr.substr(len + 1, 2);
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
};

/**
 * 设置统一的网络请求头部参数
 * @deprecated Use `setHclGlobalConfig` instead.
 * @param {any} {platform=7
 * @param {any} grayId=''}
 * @returns {any}
 */
export function setBasicHeader({ platform = 7, grayId = '' }) {
  setGlobalEnv(process.env.VUE_APP_ENV_HCL);
  setGlobalRequestHeaders({
    platform: platform,
    'gray-id': grayId
  });
}

/**
 * 设置HCL组件库统一的环境配置
 * @param {Number} platform  平台标识:  pc端：7 ，wap端：10
 * @param {String} grayId B端用户id
 * @param {Boolean} isHomologous api接口是否进行同源处理
 * @returns {any}
 */
export function setHclGlobalConfig({ platform = 7, grayId = '', isHomologous = false }) {
  setGlobalEnv(process.env.VUE_APP_ENV_HCL, isHomologous);

  setGlobalRequestHeaders({
    platform: platform,
    'gray-id': grayId || sessionStorage.getItem('initGrayId') || ''
  });
}

/**
 * 自动把url中的文件名添加_750, 例如: xxxx.jpg 变成xxxx_750.jpg、如果是移动设备并且URL包含"have-wap-image"，将文件名改为750
 * @param {any} url
 * @returns {any}
 */
export function addResolutionToFilename(url, resolution = 750) {
  const { platform } = getBrowserType();
  if (platform !== 'mobile' || !url.includes('have-wap-image')) {
    return url;
  }

  const lastDotIndex = url.lastIndexOf('.');
  // 如果url没有"."，就返回原始url
  if (lastDotIndex === -1) {
    return url;
  }

  const basename = url.substring(0, lastDotIndex);
  const extension = url.substring(lastDotIndex);

  return `${basename}_${resolution}${extension}`;
}

/**
 * 字符串中的所有 img 的src 的图片地址进行适配
 * @param {any} imgString
 * @param {any} resolution=750
 * @returns {any}
 */
export function updateImagesSource(imgString, resolution = 750) {
  const updatedString = imgString.replace(
    /(<img[^>]+src=")([^">]+)"/g,
    function (_, prefix, originalSrc) {
      const updatedSrc = addResolutionToFilename(originalSrc, resolution);
      return `${prefix}${updatedSrc}"`;
    }
  );

  return updatedString;
}

/**
 * AES加密
 * @param data 需要加密的数据
 * @param key 密钥
 * @param iv 偏移量
 * @returns 加密后的数据
 */
export const encodeAES = function (data, key = 'vhall') {
  try {
    if (typeof data !== 'string') {
      data = JSON.stringify(data);
    }
    const keyWordArray = Utf8.parse(key);

    // 默认 mode: ECB , padding: Pkcs7
    const bytes = AES.encrypt(data, keyWordArray, {
      mode: MODE_ECB,
      padding: PAD_PKCS7
    });
    // 转为utf-8编码
    return bytes.toString();
  } catch (ex) {
    console.error('encodeAES error:', ex);
    return '';
  }
};

export const hexToRgba = function (hex, opacity) {
  let reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-f]{6})$/;
  let RGBA = '';
  if (reg.test(hex)) {
    RGBA = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt(
      '0x' + hex.slice(5, 7)
    )},${opacity})`;
  } else {
    RGBA = hex;
  }
  console.log(hex, RGBA, '????????');
  return RGBA;
};

/**
 * 根据域名获取对应的cookie存储级别
 * @param {any} domain
 * @returns {any}
 */
export function getCookieSaveLevel(domain = '') {
  let domainParts = domain.split('.').reverse(); // 反转域名的各部分，以便从顶级域名开始计算

  // 获取全部的域
  const level = domainParts.length - 2; // 从总长度中减去2（顶级域名和次级域名）

  // 确保不存在子域时，返回值为0
  return level > 0 ? level : 0;
}

/**
 * 从 URL 中按照指定级别提取域名
 // 示例：
 const url1 = 'live.xfusion.com';
 console.log(extractDomain(url1));  // 输出：'.xfusion.com'，因为没有指定级别，默认为1
 console.log(extractDomain(url1, 1));  // 输出：'.xfusion.com'
 console.log(extractDomain(url1, 2));  // 输出：'.live.xfusion.com'

 const url2 = 'test02-diy.event.vhallyun.com';
 console.log(extractDomain(url2));  // 输出：'.vhallyun.com'，因为没有指定级别，默认为1
 console.log(extractDomain(url2, 1));  // 输出：'.vhallyun.com'
 console.log(extractDomain(url2, 2));  // 输出：'.event.vhallyun.com'
 console.log(extractDomain(url2, 3)); // 输出：''（因为只有两级域名，没有三级域名）
 * @param {string} url - 原始URL
 * @param {number} level - 想要提取的域名级别
 * @return {string} 按照指定级别从URL中提取出的域名
 */
export function extractDomain(url, level) {
  level = typeof level === 'undefined' ? 1 : level;
  const urlParts = url.split('.');
  if (urlParts.length < level + 1) {
    return '';
  }
  switch (level) {
    case 1:
      return '.' + urlParts.slice(-2).join('.');
    default:
      return '.' + urlParts.slice(-level - 1).join('.');
  }
}

export const DependencyLoader = {
  _loadedDependencies: {},

  load(dependencies) {
    // 将每个依赖转换成带有URL和ID的对象
    const promises = dependencies.map(({ url, id }) => {
      if (id in this._loadedDependencies) {
        // 如果该依赖已加载，直接返回Promise resolve
        return Promise.resolve(id);
      } else if (loadjs.isDefined(id)) {
        // 如果该依赖正在加载中，返回对应的loadjs promise状态
        return new Promise((resolve, reject) => {
          loadjs.ready(id, {
            success: () => {
              this._loadedDependencies[id] = true;
              resolve(id);
            },
            error: () => {
              reject(new Error(`Cannot load dependency: ${id}`));
            }
          });
        });
      } else {
        // 加载新的依赖库并在完成时设置为已加载
        return new Promise((resolve, reject) => {
          loadjs(url, id, {
            success: () => {
              this._loadedDependencies[id] = true;
              resolve(id);
            },
            error: () => {
              reject(new Error(`Cannot load dependency: ${id}`));
            }
          });
        });
      }
    });

    // 等待所有依赖加载完毕
    return Promise.all(promises);
  }
};
export function loadStyles(href) {
  var fileHref = document.createElement('link');
  fileHref.setAttribute('rel', 'stylesheet');
  fileHref.setAttribute('type', 'text/css');
  fileHref.setAttribute('href', href);
  document.head.appendChild(fileHref);
}

/**
 * 链接追加多个参数
 * @param url
 * @param params
 * @returns {string}
 */
export function addParamsToUrl(url, params = {}) {
  var a = document.createElement('a');
  a.href = url;

  let queryParams = new URLSearchParams(a.search);

  // 遍历传入的参数对象
  for (let key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      // 如果 URL 中已有该参数，则替换值，否则添加参数
      if (queryParams.has(key)) {
        queryParams.set(key, encodeURIComponent(params[key]));
      } else {
        queryParams.append(key, encodeURIComponent(params[key]));
      }
    }
  }

  a.search = queryParams.toString();

  return a.href;
}
export function observeHeightChange(
  targetNode,
  callback,
  config = {
    attributes: true, // 观察属性变化（通常涉及高度变化）
    childList: true, // 观察子节点变化
    subtree: false // 不观察子节点的子节点
  }
) {
  // 检查传入的参数是否合理
  if (!(targetNode instanceof HTMLElement)) {
    throw new Error('targetNode must be an instance of HTMLElement');
  }
  if (typeof callback !== 'function') {
    throw new Error('callback must be a function');
  }

  // 保存上一个高度以便比较
  let lastHeight = targetNode.offsetHeight;

  // 创建观察者实例并定义回调函数
  const observer = new MutationObserver(mutationsList => {
    callback();
  });

  // 开始观察目标节点
  observer.observe(targetNode, config);

  // 返回一个解除观察的函数，可以在需要时调用停止观察
  return () => observer.disconnect();
}

// 当需要停止观察时，调用 stopObserving() 函数

// 取[min, max]之间的随机整数
export function genRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * 获取字符串长度(英文占1个字节，中文汉字占2个字节)
 * @param {*} str
 * @returns
 */
export function getByteLen(str) {
  let realLength = 0;
  for (var i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) realLength += 1;
    else realLength += 2;
  }
  return realLength;
}
export function insertTextAtCursor(inputElement, textToInsert) {
  // 检查输入元素是否有效
  if (!inputElement || (inputElement.tagName !== 'INPUT' && inputElement.tagName !== 'TEXTAREA')) {
    console.error('Invalid input element provided');
    return;
  }

  // 获取当前光标位置
  const startPos = inputElement.selectionStart;
  const endPos = inputElement.selectionEnd;
  // 在光标位置插入文本
  inputElement.value =
    inputElement.value.substring(0, startPos) +
    textToInsert +
    inputElement.value.substring(endPos, inputElement.value.length);
  // 更新光标位置（如果需要）
  // 这里我们将光标放在插入文本的后面
  inputElement.selectionStart = startPos + textToInsert.length;
  inputElement.selectionEnd = startPos + textToInsert.length;
  return inputElement.value;
}

/**
 * 安全的json转换
 * @param {*} val
 */
export function safeJsonParse(val) {
  const type = Object.prototype.toString.call(val);
  if (['[object Array]', '[object Object]', '[object Null]'].includes(type)) return val;
  try {
    return JSON.parse(val);
  } catch (ex) {
    return null;
  }
}

/**
 * 给指定的 path 拼接查询参数，并且支持处理原路径上已经存在同名参数的情况，你可以选择是否覆盖这些参数
 * @param {string} path 原路径
 * @param {object} params 待拼接的参数对象
 * @param {boolean} override 是否覆盖同名参数,默认false
 * @returns
 */
export function appendQueryParamsToPath(path, params, override = false) {
  let existingParams = {};
  const queryIndex = path.indexOf('?');
  if (queryIndex !== -1) {
    // 存在问号, 取问号后面存在的参数放入existingParams对象
    const existingQuery = path.slice(queryIndex + 1);
    const pairs = existingQuery.split('&');
    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      if (key) {
        existingParams[decodeURIComponent(key)] = decodeURIComponent(value || '');
      }
    }
  }
  let newQueryString = '';
  for (const [key, value] of Object.entries(params)) {
    if (override || !(key in existingParams)) {
      if (newQueryString) {
        newQueryString += '&';
      }
      newQueryString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
  }
  if (newQueryString) {
    if (queryIndex == -1) {
      path = path + '?' + newQueryString; // 没有问号
    } else {
      // 有问号的情况。区分？后面有参数和没有参数
      const isExistingParamsEmpty = Object.keys(existingParams).length === 0;
      path = isExistingParamsEmpty ? path + newQueryString : path + '&' + newQueryString;
    }
  }
  return path;
}

/**
 * 判断一个值是否是 min 到 max 范围内的整数（包含边界，允许负整数和零）
 * @param {Number} value 值
 * @param {Number} min 最小值
 * @param {Number} max 最大值
 * @returns
 */
export function isIntegerInRange(value, min = -Infinity, max = Infinity) {
  // 校验参数有效性：min 和 max 必须为数字且 min ≤ max
  if (typeof min !== 'number' || typeof max !== 'number' || min > max) {
    throw new Error('Invalid range: min must be a number ≤ max');
  }
  return Number.isInteger(value) && value >= min && value <= max;
}

/*
 * 通用获取URL中的参数值，支持从query、hash或两者同时获取（支持单个key或多个key数组, 使用URLSearchParams解码参数值）
 *
 * @param {string|string[]} [keys] - 可选参数名或参数名数组
 * @param {Object} [options] - 配置选项
 * @param {string} [options.url=window.location.href] - 可选的URL字符串
 * @param {'query'|'hash'|'both'} [options.source='query'] - 参数来源：'query'（默认）| 'hash' | 'both'
 * @returns {string|Object|undefined} - 返回值取决于调用方式：
 *   - 无参数: 返回所有参数（Object）
 *   - 单个key: 返回对应参数值（string或undefined）
 *   - 多个key: 返回包含指定参数的对象（Object）
 *   - 空字符串/空数组: 返回空对象（Object）
 */
export function getUrlParams(keys, options = {}) {
  // 参数校验
  if (keys !== undefined && typeof keys !== 'string' && !Array.isArray(keys)) {
    throw new Error('keys must be a string, array, or undefined');
  }

  // 自动修剪字符串key的首尾空格
  if (typeof keys === 'string') {
    keys = keys.trim();
  }

  // 处理空输入（直接返回空对象）
  if (keys === '' || (Array.isArray(keys) && keys.length === 0)) {
    return {};
  }

  // 解析URL
  const { url = window.location.href, source = 'query' } = options;

  try {
    // 创建URL对象解析传入的URL
    // 注意：第二个参数'https://dummy.base'是必要的基础URL，用于处理以下情况：
    // 1. 当url是相对URL时（如"?a=1"或"/path?a=1"），提供解析基准
    // 2. 当url为空字符串时，避免解析错误
    // 该基础URL仅作为解析参考，不会影响最终结果（仅提取search/hash部分）
    const urlObj = new URL(url, 'https://dummy.base');

    // 根据source获取对应的参数（优化后版本）
    let params;
    switch (source) {
      case 'hash':
        params = new URLSearchParams(urlObj.hash.slice(1));
        break;
      case 'both':
        // 合并query和hash参数，hash参数优先级更高
        params = new URLSearchParams(urlObj.searchParams);
        new URLSearchParams(urlObj.hash.slice(1)).forEach((value, key) => {
          params.set(key, value);
        });
        break;
      case 'query':
      default:
        params = urlObj.searchParams;
    }

    // 返回结果
    if (keys === undefined) {
      return Object.fromEntries(params.entries());
    }

    if (typeof keys === 'string') {
      return params.get(keys.trim());
    }

    // 返回多个参数
    return Object.fromEntries(
      keys.reduce((entries, key) => {
        const trimmedKey = typeof key === 'string' ? key.trim() : key;
        if (trimmedKey !== '') {
          entries.push([trimmedKey, params.get(trimmedKey)]);
        }
        return entries;
      }, [])
    );
  } catch (error) {
    console.error(`URL参数解析失败: ${url}`, error);

    // 解析失败时的统一返回逻辑：
    // - 单个字符串key返回undefined
    // - 其他情况返回空对象{}
    return typeof keys === 'string' ? undefined : {};
  }
}

//获取URL中的query参数值
export function getUrlQueryParams(keys, options = {}) {
  return getUrlParams(keys, { ...options, source: 'query' });
}

/**
 * 删除URL中的指定参数并更新浏览器地址栏
 * @param {string|string[]} keys - 待删除的参数名（支持单个字符串或字符串数组）
 * @param {Object} [options] - 配置选项
 * @param {boolean} [options.reload=false] - 是否刷新页面（默认false）
 * @param {'query'|'hash'|'both'} [options.source='query'] - 删除参数的来源（默认query）
 * @returns {boolean} - 是否成功更新URL
 */
export function removeUrlParamsAndUpdate(keys, options = {}) {
  const { reload = false, source = 'query' } = options;

  // 参数校验
  if (!keys) return false;

  // 统一转换为数组
  const keysArray = Array.isArray(keys)
    ? keys.filter(key => typeof key === 'string' && key.trim())
    : [keys].filter(key => typeof key === 'string' && key.trim());

  if (keysArray.length === 0) return false;

  try {
    const url = new URL(window.location.href);

    // 根据source删除对应位置的参数
    switch (source) {
      case 'query':
        keysArray.forEach(key => url.searchParams.delete(key));
        break;
      case 'hash':
        {
          const hashParams = new URLSearchParams(url.hash.slice(1));
          keysArray.forEach(key => hashParams.delete(key));
          url.hash = hashParams.toString();
        }
        break;
      case 'both':
        {
          keysArray.forEach(key => url.searchParams.delete(key));
          const hashParams = new URLSearchParams(url.hash.slice(1));
          keysArray.forEach(key => hashParams.delete(key));
          url.hash = hashParams.toString();
        }
        break;
      default:
        throw new Error(`Invalid source: ${source}`);
    }

    const targetUrl = url.toString();
    // 更新URL
    if (reload) {
      window.location.replace(targetUrl);
    } else {
      window.history.replaceState({}, document.title, targetUrl);
    }
    return targetUrl;
  } catch (error) {
    console.error('Failed to update URL:', error);
    return false;
  }
}

export function isInIframe() {
  try {
    return window.top !== window.self;
  } catch (e) {
    // 跨域情况下，如果能捕获到错误，说明一定在 iframe 中
    return true;
  }
}
